export class ExceptionMessage {
  static generateMessage(err, defaultMessage) {
    let message = {
      type: 'error',
      text: defaultMessage,
      show: true,
      detail: null
    }

    message.text = this.parseMessage(err, defaultMessage)

    if (!err) return message

    if (err.response?.data) {
      if (err.response.data.detail) {
        message.detail = err.response.data.detail
      }
    } else if (err.detail) {
      message.detail = err.detail
    }

    return message
  }

  static parseMessage(err, defaultMessage) {
    let message = defaultMessage
    if (!err) return message

    if (typeof err === 'string' || err instanceof String) return err

    if (err.response?.data) {
      if (err.response.data.exceptionMessage) {
        message = err.response.data.exceptionMessage
      } else if (err.response.data.message) {
        message = err.response.data.message
      } else if (err.response.data.title) {
        message = err.response.data.title
      } else if (err.response.data.error) {
        message = err.response.data.error
      }
    } else if (err.message) {
      message = err.message
    }

    return message
  }
}

export default { ExceptionMessage }
